import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/app/operations` (exact) → redirect to the single Operations Workspace.
 * This is a *leaf* under the operations layout, so its beforeLoad only
 * runs for the exact parent path — child routes like /desk are unaffected.
 */
export const Route = createFileRoute("/_authenticated/app/operations/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/operations/desk", replace: true });
  },
});